/**
 * Resolution
 * @readonly
 * @enum {number}
 */
export const Resolution = Object.freeze({
  WEB: 72,
  HIGH_DPI: 150,
  PRINT: 360,
});

export const INCH_IN_CM = 2.54;
export const INCH_IN_MM = INCH_IN_CM * 10;

/**
 *
 * @param {number} value
 * @param {Resolution} resolution
 * @return {number}
 */
export function mmToPx(value, resolution = Resolution.WEB) {
  return (value * resolution) / INCH_IN_MM;
}

export function pxToMm(value, resolution = Resolution.WEB) {
  return (value * INCH_IN_MM) / resolution;
}

/**
 *
 * @param {number} diameter
 * @return {number}
 */
export function getPerimeter(diameter) {
  return Math.PI * diameter;
}

/**
 *
 * @param {number} value
 * @param {number} from
 * @param {number} to
 * @return {number}
 */
export function scale(value, from, to) {
  return (value * to) / from;
}
